import { render, staticRenderFns } from "./ShunyiHomePage.vue?vue&type=template&id=ad812270&scoped=true"
import script from "./ShunyiHomePage.vue?vue&type=script&lang=js"
export * from "./ShunyiHomePage.vue?vue&type=script&lang=js"
import style0 from "./ShunyiHomePage.vue?vue&type=style&index=0&id=ad812270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad812270",
  null
  
)

export default component.exports